import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "mt-1" }
const _hoisted_3 = { class: "d-flex justify-end" }

export function render(_ctx, _cache) {
  const _component_v_textarea = _resolveComponent("v-textarea")
  const _component_BaseButton = _resolveComponent("BaseButton")
  const _component_v_form = _resolveComponent("v-form")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("h1", null, "Please enter more information about this case", -1)),
      _createElementVNode("div", _hoisted_2, "Case title: " + _toDisplayString(_ctx.caseModel.title), 1)
    ]),
    _createVNode(_component_v_form, {
      ref: "form",
      onSubmit: _withModifiers(_ctx.submit, ["prevent"])
    }, {
      default: _withCtx(() => [
        _cache[4] || (_cache[4] = _createElementVNode("p", { class: "mb-2" }, "Please enter the following information:", -1)),
        _createElementVNode("div", null, [
          _cache[2] || (_cache[2] = _createElementVNode("label", { class: "d-block mb-2" }, "Solution (in English) *", -1)),
          _createVNode(_component_v_textarea, {
            variant: "outlined",
            rules: [(v) => !!v || 'Solution is required'],
            loading: _ctx.loading,
            placeholder: "Please enter the solution to this case in English",
            modelValue: _ctx.solution,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.solution) = $event))
          }, null, 8, ["rules", "loading", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_BaseButton, {
            width: 200,
            submit: "",
            disabled: _ctx.loading
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode(" Submit ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"])
  ]))
}